// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footer-copyright__logo":"Footer_footer-copyright__logo__Y3vvY"};